import apiService from '../../services/api';
import _ from 'lodash';

const state = {
    currentUser: localStorage.getItem('currentUser')
        ? JSON.parse(localStorage.getItem('currentUser'))
        : {}
};

const getters = {
    isAuthenticated: state => !!_.get(state, 'currentUser.id'),
    currentUser: state => state.currentUser
};

const actions = {
    actionLogin: async (context, params) => {
        const response = await apiService.post('auth.login', params);
        context.commit('LOGIN_SUCCESS', response);
    },
    actionChangePass: (context, params) => {
        return apiService.post('auth.changePass', params);
    },
    actionLogout: context => {
        return new Promise((resolve, reject) => {
            context.commit('LOGOUT_SUCCESS');
            resolve();
        });
    },
    getCurrentUserDetail: context => {
        return apiService
            .get('user.profile', {
                id: state.currentUser.id
            })
            .then(response => {
                context.commit('UPDATE_CURRENT_USER_DETAIL_STATE', response);
            });
    },
    updateState: (context, payload) => {
        context.commit('UPDATE_STATE', payload);
    }
};

const mutations = {
    LOGIN_SUCCESS: (state, response) => {
        state.currentUser = response;
        localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
    },
    LOGOUT_SUCCESS: state => {
        state.currentUser = null;
        localStorage.removeItem('currentUser');
    },
    UPDATE_CURRENT_USER_DETAIL_STATE: (state, response) => {
        state.currentUser = {
            ...state.currentUser,
            userDetail: response
        };
        localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
    },
    UPDATE_STATE: (state, payload) => {
        const { stateName, value } = payload;
        state[stateName] = value;
        if (stateName === 'currentUser') {
            localStorage.setItem('currentUser', JSON.stringify(state.currentUser));
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
